export async function getJsonApi<T>(path: string): Promise<T | undefined> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}${path}`, {
            method: "GET",
            headers: {
                "X-PlayerSessionId": getPlayerSessionId(),
            },
        });

        if (!response.ok) {
            new Error("Network response was not ok");
        }

        return await response.json() as Promise<T>;
    } catch (error) {
        console.error("Failed to fetch:", error);
        // Handle or throw the error as appropriate for your application
        return undefined;
    }
}


export async function postJsonApi<T1, T2>(path: string, data?: T2): Promise<T1 | undefined> {
    return methodJsonApi("POST", path, data);
}

export async function methodJsonApi<T1, T2>(method: string, path: string, data?: T2): Promise<T1 | undefined> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}${path}`, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
            body: data ? JSON.stringify(data) : undefined,
        });

        if (!response.ok) {
            new Error("Network response was not ok");
        }

        return await response.json() as Promise<T1>;
    } catch (error) {
        console.error("Failed to fetch:", error);
        // Handle or throw the error as appropriate for your application
        return undefined;
    }
}

export async function userMethod(method: string, path: string, data: any): Promise<Response | undefined> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}${path}`, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
            body: data ? JSON.stringify(data) : undefined,
        });

        if (!response.ok) {
            new Error("Network response was not ok");
        }

        return response;
    } catch (error) {
        console.error("Failed to fetch:", error);
        // Handle or throw the error as appropriate for your application
        return undefined;
    }
}

function getPlayerSessionId(): string {
    let playerSessionId: string | null = localStorage.getItem("playerSessionId");

    if (!playerSessionId) {
        playerSessionId = crypto.randomUUID();

        localStorage.setItem("playerSessionId", playerSessionId);

    }

    return playerSessionId;
}



